import { render, staticRenderFns } from "./sale-preview.vue?vue&type=template&id=46c752f0&scoped=true"
import script from "./sale-preview.vue?vue&type=script&lang=js"
export * from "./sale-preview.vue?vue&type=script&lang=js"
import style0 from "./sale-preview.vue?vue&type=style&index=0&id=46c752f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c752f0",
  null
  
)

export default component.exports